import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Button, Stack } from '@mui/material'
import Multiselect from './components/Multiselect'
import Editor from 'components/editor'


const CreateModal = ({ handleRefresh, apps, category }) => {
  const uploadImage = useUploadImage()

  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [selectedApp, setSelectedApp] = useState(null);
  const [description, setDescription] = useState('')

  const appOptions = apps?.map(item => ({
    label: item?.name,
    value: item?.app_id,
  }))

  // console.log(svgIcon, "svgIcon")
  const handleModal = () => {
    setOpenAddProduct(true)
  }


  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }




  const handleSubmit = async (e) => {

    e.preventDefault();
    setProcessing(true);

    const selectedApps = JSON.parse(e.target.apps.value)

    const payload = {
      name: e.target.name.value,
      key:e.target.key.value,
      category: e.target.category.value,
      description,
      video_path: e.target.video_path.value,
      app_id: selectedApps ? selectedApps : [],
    };

    console.log(payload, "payload");



    const { response } = await AppService.Tools.create({ payload });

    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} >
            <MDTypography variant="h5" mb={2}>
              Create Tool
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Key</MDTypography>
              <MDInput label="Key" name="key" fullWidth required />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Apps
              </MDTypography>
              <Multiselect data={appOptions} isMulti={true} name="apps" />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Category</MDTypography>
              <MDInput
                select
                name="category"
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select a Category</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </MDInput>
            </MDBox>





            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Video URL</MDTypography>
              <MDInput label="Video URL" name="video_path" fullWidth />
            </MDBox>



            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
